module["exports"] = [
  "#{street_name}#{building_number}號"
];
